<template>
  <PageHeader title="Agents" :breadcrumbs="[{ label: 'Beta' }, { label: 'Outreach' }]" />

  <div class="p-4">

    <div class="space-y-6">
      <!-- Agents -->
      <AgentsCard
        :agents="agents"
        @agents-updated="agents = $event"
        @open-agent-modal="openAgentModal"
      />

      <!-- Tools -->
      <ToolsCard
        :tools="tools"
        @open-tool-modal="openToolModal"
      />
    </div>

    <!-- Agent Modal -->
    <AgentModal
      v-model="isAgentModalOpen"
      :agent="selectedAgent"
      :agents="agents"
      :tools="tools"
      @save="handleSaveAgent"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AgentsCard from './Agent/AgentsCard.vue'
import ToolsCard from './Agent/ToolsCard.vue'
import AgentModal from './Agent/Modals/AgentModal.vue'
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import { useToast } from 'vue-toastification'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

export default {
  name: 'AgentTab',
  components: {
    AgentsCard,
    ToolsCard,
    AgentModal,
    PageHeader,
  },
  data() {
    return {
      agents: [],
      tools: [],
      selectedAgent: null,
      isAgentModalOpen: false,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const toast = useToast()
      try {
        const [agentsResponse, toolsResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}api/outreach/agents/`, { withCredentials: true }),
          axios.get(`${API_BASE_URL}api/outreach/agent-tools/`, { withCredentials: true }),
        ])
        this.agents = agentsResponse.data
        this.tools = toolsResponse.data
      } catch (error) {
        console.error('Failed to fetch data:', error)
        toast.error('Failed to load agents')
      }
    },
    openAgentModal(agentId) {
      const toast = useToast()
      // New agent
      if (agentId === null) {
        this.selectedAgent = null
        this.isAgentModalOpen = true
        return
      }

      const agent = this.agents.find((a) => a.id === agentId)
      if (!agent) {
        toast.error('Agent not found')
        return
      }

      this.selectedAgent = agent
      this.isAgentModalOpen = true
    },
    openToolModal(toolId) {
      const toast = useToast()
      // Placeholder for future tool modal functionality
      console.log('Open tool modal for tool:', toolId)
      toast.info('Tool details modal coming soon')
    },
    async handleSaveAgent(agent) {
      const toast = useToast()
      try {
        const isUpdate = !!agent.id

        if (isUpdate) {
          await axios.patch(`${API_BASE_URL}api/outreach/agents/${agent.id}/`, agent, { 
            withCredentials: true 
          })
          toast.success('Agent updated successfully')
        } else {
          await axios.post(`${API_BASE_URL}api/outreach/agents/`, agent, { 
            withCredentials: true 
          })
          toast.success('Agent created successfully')
        }

        const response = await axios.get(`${API_BASE_URL}api/outreach/agents/`, { 
          withCredentials: true 
        })
        this.agents = response.data

        this.isAgentModalOpen = false
        this.selectedAgent = null
      } catch (error) {
        console.error('Failed to save agent:', error)
        toast.error('Failed to save agent. Please try again.')
      }
    },
  },
}
</script>
